import { render, staticRenderFns } from "./AccidentDocumentationBasedata.vue?vue&type=template&id=5227a89c"
import script from "./AccidentDocumentationBasedata.vue?vue&type=script&lang=js"
export * from "./AccidentDocumentationBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports